import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { reusableGridSort } from '../grid/reusable-grid.function';

import { FocusSelectorSortActiveForPerformerGrid } from './active-for-performer-sort.action';

export function focusSelectorSortActiveForPerformerGridReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSortActiveForPerformerGrid>,
): FocusSelectorState {
    const { column } = action.payload;
    const { sortDefs, defaultSortDefs } = state.activeFocusesPerformerGrid;
    const nextSortDefs = reusableGridSort(column, sortDefs, defaultSortDefs);

    return {
        ...state,

        activeFocusesPerformerGrid: {
            ...state.activeFocusesPerformerGrid,
            sortDefs: nextSortDefs,
        },
    };
}
